import { Typography } from "antd";
import { useNavigate } from "react-router-dom";

import smartLogoDefault from "../../../common/images/svg/smart-logo-icon.svg";
import { ButtonOutlinedCustom } from "../../../components/button/buttonOulined";
import { useNotification } from "../../../components/providers/notification/useNotification";
import { convertCurrency } from "../../../utils/hooks/convertRate";
import useResponsive from "../../../utils/hooks/useResponsive";
import { formatNumber } from "../../../utils/list.utils";

interface ItemProps {
  item: {
    id: number;
    symbol: string;
    name: string;
    iconPath: string;
    totalBalance: number;
    decimals: number;
    amount: number;
    avlBalance: number;
  };
  method: string;
  setSelectedItem: (item: any) => void;
  setPrevWithdraw: React.Dispatch<any>;
  setDeposit: (item: any) => void;
  setWithdraw: (item: any) => void;
  setExchange: (item: any) => void;
  currencyOption: string;
  canAction: boolean;
  rates: {
    EUR: string;
    ETH: string;
    DAI: string;
    USDT: string;
    USD: string;
  };
}

const Crypto = ["USDT", "DAI", "ETH"];

const Item = ({
  item,
  method,
  setSelectedItem,
  setPrevWithdraw,
  setDeposit,
  setWithdraw,
  setExchange,
  currencyOption,
  canAction,
  rates,
}: ItemProps) => {
  const navigate = useNavigate();
  const { open: openNotification } = useNotification();
  const { isTablet } = useResponsive();

  const handleDeposit = (e: any) => {
    e.stopPropagation();
    if (canAction) {
      setDeposit(item);
    } else {
      if (openNotification) {
        openNotification?.({
          key: "not_permission",
          message:
            "Your account is currently under review by the admin. You will be able to use this feature once the review is complete and your account is verified.",
          type: "error",
        });
      }
    }
  };

  const handleWithdraw = (e: any) => {
    e.stopPropagation();
    if (canAction) {
      setWithdraw(item);
      setPrevWithdraw(item);
    } else {
      if (openNotification) {
        openNotification?.({
          key: "not_permission",
          message:
            "Your account is currently under review by the admin. You will be able to use this feature once the review is complete and your account is verified.",
          type: "error",
        });
      }
    }
  };

  const handleExchange = (e: any) => {
    e.stopPropagation();
    if (canAction) {
      setExchange(item);
      setPrevWithdraw(item);
    } else {
      if (openNotification) {
        openNotification?.({
          key: "not_permission",
          message:
            "Your account is currently under review by the admin. You will be able to use this feature once the review is complete and your account is verified.",
          type: "error",
        });
      }
    }
  };

  return (
    <div
      className={`frame-home-right-item ${"frame-home-right-item-hover"}`}
      onClick={() => {
        navigate(`/home?currency=${item.id}`);
        setSelectedItem(item);
      }}
    >
      <div className={"item-infomation"}>
        <div className={"item-infomation-name"}>
          <div className={"item-infomation-name-avatar"}>
            <img
              src={
                `${process.env.REACT_APP_ROOT_URL}/${item.iconPath}`
              }
              onError={(e) => {
                e.currentTarget.src = smartLogoDefault;
              }}
              alt="currency"
              style={{ objectFit: "cover", width: "100%", height: "100%" }}
            />
          </div>
        </div>
        <div className={"box-value"}>
          <Typography
            style={{
              fontSize: isTablet ? 14 : 16,
              fontWeight: 700,
              color: "white",
            }}
          >
            {item.symbol}
          </Typography>
          <Typography
            style={{
              fontSize: isTablet ? 12 : 14,
              fontWeight: 400,
              color: "white",
            }}
          >
            {item.name}
          </Typography>
        </div>
        <div className={"box-value"}>
          <Typography
            style={{
              fontSize: isTablet ? 12 : 14,
              fontWeight: 400,
              color: "rgba(255, 255, 255, 0.6)",
            }}
          >
            {"Balance"}
          </Typography>
          <Typography
            style={{
              fontSize: isTablet ? 12 : 14,
              fontWeight: 700,
              color: "white",
            }}
          >
            {formatNumber(
              Number(item?.totalBalance || 0),
              Number(item?.decimals) || 2
            )}
          </Typography>
        </div>
        <div className={"box-value"}>
          <Typography
            style={{
              fontSize: isTablet ? 12 : 14,
              fontWeight: 400,
              color: "rgba(255, 255, 255, 0.6)",
            }}
          >
            {method === "CRYPTO" ? "Amount" : "Available balance"}
          </Typography>
          {Crypto.includes(item?.symbol) ? (
            <Typography
              style={{
                fontSize: isTablet ? 12 : 14,
                fontWeight: 700,
                color: "white",
              }}
            >
              {currencyOption === "USD" ? "$" : "€"}
              {formatNumber(
                convertCurrency(
                  Number(item?.totalBalance),
                  item?.symbol,
                  currencyOption,
                  rates
                ),
                2
              )}
            </Typography>
          ) : (
            <Typography
              style={{
                fontSize: isTablet ? 12 : 14,
                fontWeight: 700,
                color: "white",
              }}
            >
              {formatNumber(Number(item?.avlBalance || 0), 2)}
            </Typography>
          )}
        </div>
      </div>

      {method === "CRYPTO" ? (
        <>
          <div className={"item-option"}>
            <ButtonOutlinedCustom
              size={isTablet ? "small" : "medium"}
              text="Exchange"
              width={97}
              onClick={handleExchange}
            />
            <ButtonOutlinedCustom
              size={isTablet ? "small" : "medium"}
              text="Deposit"
              width={84}
              onClick={handleDeposit}
            />
            <ButtonOutlinedCustom
              size={isTablet ? "small" : "medium"}
              text="Withdraw"
              width={97}
              onClick={handleWithdraw}
            />
          </div>
        </>
      ) : (
        <ButtonOutlinedCustom
          size={isTablet ? "small" : "medium"}
          text="Exchange"
          width={97}
          onClick={handleExchange}
        />
      )}
    </div>
  );
};

export default Item;
